import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {AiReportsFilter} from './AiReportsFilter';
import {AiReportsTable} from './AiReportsTable';
import {AiReportsFooter} from './AiReportsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function AiReportsCard() {

  return (
    // @ts-ignore
    <Card className={'flex-fill bg-transparent shadow-none'} id={'ai-reports-card'}>
      <AiReportsFilter/>
      <AiReportsTable/>
      <FooterBar>
        <AiReportsFooter/>
      </FooterBar>
    </Card>
  );
}
